import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import { chMarkPatientAsPotentialDuplicateMutation as ChMarkPatientAsPotentialDuplicateMutationType } from "@/modules/patients/services/ch/__generated__/chMarkPatientAsPotentialDuplicateMutation.graphql"
import { chMarkPatientAsPotentialDuplicateMutation as chMutation } from "@/modules/patients/services/ch/chMarkPatientAsPotentialDuplicateMutation"
import { deMarkPatientAsPotentialDuplicateMutation as DeMarkPatientAsPotentialDuplicateMutationType } from "@/modules/patients/services/de/__generated__/deMarkPatientAsPotentialDuplicateMutation.graphql"
import { deMarkPatientAsPotentialDuplicateMutation as deMutation } from "@/modules/patients/services/de/deMarkPatientAsPotentialDuplicateMutation"

const useMarkPatientAsPotentialDuplicateMutation = (country: Country) => {
  const mutation = (() => {
    switch (country) {
      case "CH":
        return chMutation
      case "DE":
        return deMutation
    }
  })()

  return useMutationWithErrorDialog<
    ChMarkPatientAsPotentialDuplicateMutationType & DeMarkPatientAsPotentialDuplicateMutationType
  >(mutation, {
    considerErrorAsBlocking: (errorTypeName) => errorTypeName !== "PatientAlreadyMarkedAsPotentialDuplicate",
  })
}

export { useMarkPatientAsPotentialDuplicateMutation }
